<template>
  <div class="scroll-wall">
    <div class="title">最新参与用户</div>
    <swiper v-if="finalList && finalList.length" ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="(item, groupIdx) in finalList" :key="groupIdx" class="swiper-no-swiping">
        <div class="inline">
          <div class="name-area">
            <i :style="{ color: themeColor }" class="icon iconfont icontongzhi"></i>
            <span>{{ item.name }}</span>
          </div>
          <div class="tel-area">{{ item.phone }}</div>
          <div class="desc-area">{{ desc === 'xx分钟前' ? item.time_desc : desc }}</div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import mixin from '../mixin'

export default {
  name: 'ScrollWallDefault',
  mixins: [mixin],
  props: {
    themeColor: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      finalList: [],
      swiperOptions: {
        autoplay: {
          delay: 1500
        },
        spaceBetween: 0,
        disableOnInteraction: false,
        loop: true,
        noSwiping: true,
        direction: 'vertical',
        speed: 1500,
        slidesPerView: 4
      }
    }
  }
}
</script>

<style lang="less" scoped>
.scroll-wall {
  position: relative;
  width: 100%;
  height: 180px;
  background: #f8f8f8;
  border-radius: 10px;
  padding: 14px 24px 0 23px;
  margin-top: 18px;
  .title {
    text-align: center;
    font-weight: 600;
    font-size: 15px;
    line-height: 21px;
    color: #000000;
    margin-bottom: 16px;
  }
}
.inline {
  width: 100%;
  height: 18px;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.name-area,
.tel-area,
.desc-area {
  display: inline-block;
  width: 33.333%;
  font-size: 13px;
  line-height: 1;
  color: #666666;
}
.name-area {
  display: flex;
  align-items: center;
  & > i {
    font-size: 18px;
    margin-right: 9px;
  }
  text-align: left;
}
.tel-area {
  text-align: center;
}
.desc-area {
  text-align: right;
}
.swiper-container {
  z-index: 0 !important;
  width: 100%;
  height: 120px;
}
//.swiper-wrapper {
//  width: 100% !important;
//  height: 100% !important;
//}
.swiper-slide {
  width: 100% !important;
}
</style>
